const data = {
    events:[
        {
            "id": 1,
            "title": "Dred Scott v. Sandford",
            "event": "The Supreme Court rules that Black people are not U.S. citizens and have no legal rights under the Constitution. In his decision, Chief Justice Taney writes, “the Black man has no rights which the white man is bound to respect.”",
            "importantPeopleAssociates": ["Dred Scott"],
            "year": 1857,
            "yearSort": 1857,
            "location": "St. Louis, Missouri",
            "broaderLoc":["Missouri"],
            "Source type": "newspaper",
            "sourceThumbnail": "tn-timeline-main-1.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Eliza and Lizzie, children of Dred Scott; Dred Scott; His wife Harriet",
            "affiliatedPrimarySourcesLink": "https://www.loc.gov/item/2002707034/",
            "Source image for full view": "timeline_mainevent-1.jpg",
            "topics": "Legal Cases",
            "Notes": "cited in film",
            "highlighted":true,
            
        },
        {
            "id": 2,
            "title": "14th Amendment to the U.S. Constitution",
            "event": "The 14th Amendment is ratified providing Black people citizenship status and entitling all persons to equal protection of the law. This is Thurgood Marshall's focus through litigation.",
            "year": 1868,
            "yearSort": 1868,
            "location": "Washington, D.C.",
            "broaderLoc":["Washington, D.C."],
            "Source type": "video",
            "sourceThumbnail": "tn-timeline-main-2.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Becoming Thurgood: America's Social Architect",
            "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/1106261145?h=5c7f00a2a6&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" style=\"width:100%;height:100%;\" title=\"Timeline1-14thAmendment\"></iframe><script src=\"https://player.vimeo.com/api/player.js\"></script>",
            "text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam viverra nisl blandit, rutrum lorem vel, tristique nulla. Cras libero quam, aliquam quis aliquet eget, viverra sed est. Fusce varius turpis odio, ut porta felis interdum a. Donec lacinia nunc sed sapien fringilla faucibus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Etiam semper enim id lacus aliquet, nec pretium nisl euismod. Aenean in felis pulvinar, mollis urna nec, ultrices nulla. Quisque gravida et urna nec condimentum. Praesent condimentum dapibus risus in sollicitudin. Nam id mauris et neque blandit dignissim et eget ante. Donec vitae nibh maximus, ultrices felis quis, cursus mi. Vestibulum tincidunt sit amet velit non mollis. Cras lacus lacus, posuere in posuere at, condimentum non purus. Interdum et malesuada fames ac ante ipsum primis in faucibus. Duis blandit velit et efficitur porttitor. Aliquam eget eros aliquet, tincidunt justo non, ullamcorper arcu. Mauris lobortis pharetra neque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Pellentesque sit amet ante elementum, venenatis lectus quis, porttitor mi. Nulla lobortis lacinia volutpat. Mauris justo tellus, maximus blandit varius vitae, accumsan vitae nisl. Aliquam commodo augue at consectetur volutpat. Integer cursus, justo in scelerisque congue, nibh turpis ultrices ipsum, ut gravida est ipsum et dui. Vivamus commodo magna leo, a porta est efficitur ac. Vestibulum ornare varius faucibus. Nullam hendrerit iaculis facilisis. Aliquam nec nibh nec augue dapibus fringilla et sit amet nibh. Maecenas fermentum porta blandit.",
            "topics": "Legislation, Politics",
            "Notes": "cited in film",
            "highlighted":true,
        },
        {
            "id": 3,
            "title": "Plessy  v. Ferguson",
            "event": "The Supreme Court upholds Louisiana's Separate Car Act. The ruling states that racial segregation is legal under the 14th Amendment if facilities are “separate but equal.” This decision allows racial segregation to continue for many years.",
            "importantPeopleAssociates": ["Justice John Marshall Harlan"],
            "year": 1896,
            "yearSort": 1896,
            "location": "New Orleans, Louisiana",
            "broaderLoc":["Louisiana"],
            "Source type": "video",
            "sourceThumbnail": "tn-timeline-main-3.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Becoming Thurgood: America's Social Architect",
            "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/1106261109?h=44ba7b7e92&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" style=\"width:100%;height:100%;\" title=\"Timeline2-Plessy\"></iframe><script src=\"https://player.vimeo.com/api/player.js\"></script>",
            "topics": "Legal Cases, Segregation",
            "Notes": "cited in film",
            "highlighted":true,
        },
        {
            "id": 4,
            "title": "Murray v. Pearson",
            "event": "Donald Gaines Murray is denied admission to the University of Maryland School of Law because of his race. Represented by Charles Hamilton Houston and Thurgood Marshall, the court rules in their favor. This is Marshall's first successful civil rights case.",
            "importantPeopleAssociates": ["Charles Hamilton Houston"],
            "year": 1936,
            "yearSort": 1936,
            "Source type": "photo",
            "sourceThumbnail": "tn-timeline-main-4.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Thurgood Marshall with client Donald Gaines Murray",
            "Source image for full view": "timeline_mainevent-4.tiff",
            "topics": "Civil Rights, Thurgood Marshall, Legal Cases",
            "highlighted":true,
            "affiliatedPrimarySourcesLink":"https://www.loc.gov/item/95517077"
        },
        {
            "id": 5,
            "title": "Alston v. School Board of City of Norfolk",
            "event": "A federal court rules that Black and white teachers in Norfolk, Virginia, must be paid equally. Thurgood Marshall argues the case, and the decision becomes a key ruling that inspires similar lawsuits across the South and helps launch Marshall's work at the Supreme Court.",
            "year": 1940,
            "yearSort": 1940,
            "location": "Norfolk, Virginia",
            "broaderLoc":["Virginia"],
            "Source type": "photo",
            "sourceThumbnail": "tn-timeline-main-5.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Alston v. School Board of City of Norfolk",
            "Source image for full view": "pending permission",
            "topics": "Legal Cases, Thurgood Marshall",
            "Notes": "Mentioned in film but no cases are cited",
            "highlighted":true,
            "affiliatedPrimarySourcesLink":"https://www.loc.gov/item/95518729"
        },
        {
            "id": 6,
            "title": "Smith v.  Allwright",
            "event": "Lonnie E. Smith, a Black dentist in Texas, is denied the right to vote in a primary election. With NAACP support, Thurgood Marshall  challenges the policy in his first U.S. Supreme Court case. The Court rules 8-1 to end white-only primaries, a major barrier to Black voters.",
            "year": 1944,
            "yearSort": 1944,
            "location": "Harris County, Texas",
            "broaderLoc":["Texas"],
            "Source type": "video",
            "sourceThumbnail": "tn-timeline-main-6.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Becoming Thurgood: America's Social Architect",
            "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/1106256199?h=42c2bc9a5c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" style=\"width:100%;height:100%;\" title=\"Timeline3-SmithAllbright\"></iframe><script src=\"https://player.vimeo.com/api/player.js\"></script>",
            "topics": "Legal Cases, Thurgood Marshall",
            "Notes": "cited in the film",
            "highlighted":true,
        },
        {
            "id": 7,
            "title": "The Groveland Cases",
            "event": "The U. S. Supreme Court overturns the convictions of Samuel Shepherd and Walter Irvin, who were falsely accused of rape. Thurgood Marshall represented them in their appeal to the Supreme Court to challenge the death sentences given by an all-white jury.",
            "year": 1951,
            "yearSort": 1951,
            "location": "Groveland, Florida",
            "broaderLoc":["Florida"],
            "Source type": "photo",
            "sourceThumbnail": "tn-timeline-main-7.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Three African American men, Walter Irvin, Charles Greenlee, and Samuel Shephard, arrested in Groveland, Florida",
            "affiliatedPrimarySourcesLink": "https://www.loc.gov/item/2002713006/",
            "Source image for full view": "timeline_mainevent-7.tif",
            "topics": "Legal Cases, Thurgood Marshall",
            "Notes": "resources: case file located on LDF Recollection website with primary source materials for teachers.",
            "highlighted":true,
        },
        {
            "id": 8,
            "title": "Bolling v. Sharpe",
            "event": "After being denied entry to white schools in Washington, D.C., a group of Black parents file a lawsuit with the help of lawyers Charles Hamilton Houston and James Nabrit Jr.. The case is dismissed, and they appeal to the Supreme Court as part of <i>Brown v. Board of Education</i>.",
            "importantPeopleAssociates": ["Charles Hamilton Houston","James Nabrit Jr."],
            "year": 1950,
            "yearSort": 1950,
            "location": "Washington, D.C.",
            "broaderLoc":["Washington, D.C."],
            "Source type": "document",
            "sourceThumbnail": "tn-timeline-main-8.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"U.S. Reports: Bolling v. Sharpe, 347 U.S. 497 (1954).",
            "affiliatedPrimarySourcesLink": "https://www.loc.gov/resource/usrep.usrep347497/?pdfPage=1&st=pdf",
            "Source image for full view": "timeline_mainevent-8.jpg",
            "topics": "Legal Cases, Segregation",
            "Notes": "cited in the film",
            "highlighted":true,
        },
        {
            "id": 9,
            "title": "Briggs v. Elliot",
            "event": "Black students in Clarendon County, South Carolina, have no access to school buses and must walk long distances. Their parents file a lawsuit demanding equal education. When segregation continues, they appeal the case to the U.S. Supreme Court as part of <i>Brown v. Board of Education</i>.",
            "year": 1950,
            "yearSort": 1950,
            "location": "Clarendon County, South Carolina",
            "broaderLoc":["South Carolina"],
            "sourceThumbnail": "tn-timeline-main-9.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Briggs v. Elliott, Civil 2657",
            "affiliatedPrimarySourcesLink": "https://catalog.archives.gov/id/279304?objectPage=253",
            "Source image for full view": "timeline_mainevent-9.jpg",
            "topics": "Legal Cases, Segregation",
            "Notes": "Devil in the Grove book as a resource for teachers.",
            "highlighted":true,
        },
        {
            "id": 10,
            "title": "Davis v. County School Board",
            "event": "Students at Moton High School in Prince Edward County, Virginia, walk out to protest poor school facilities. The NAACP takes their case, arguing that segregation causes these unfair conditions and violates the 14th Amendment. After losing in federal court, they appeal to the Supreme Court as part of <i>Brown v. Board of Education</i>.",
            "year": 1951,
            "yearSort": 1951,
            "location": "Prince Edward County, Virginia",
            "broaderLoc":["Virginia"],
            "Source type": "photo",
            "sourceThumbnail": "tn-timeline-main-10.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Moton High School Classroom ca. 1951",
            "affiliatedPrimarySourcesLink": "https://www.docsteach.org/documents/document/moton-class",
            "Source image for full view": "timeline_mainevent-10.jpg",
            "Source description": "Moton High School Classroom, Plaintiff's Exhibit No. 32 (photo)",
            "topics": "Legal Cases, Segregation",
            "Notes": "cited in film",
            "highlighted":true,
        },
        {
            "id": 11,
            "title": "Belton (Bulah) v. Gebhart",
            "event": "Black students in Hockessin, Delaware, sue the state board of education, saying segregation violates the 14th Amendment. Some are denied entry to local white schools or access to buses. Their case is later combined into <i>Brown v. Board of Education</i> at the U.S. Supreme Court.",
            "importantPeopleAssociates": ["Louis L. Redding"],
            "year": 1951,
            "yearSort": 1951,
            "location": "Hockessin, Delaware",
            "broaderLoc":["Delaware"],
            "Source type": "photo",
            "sourceThumbnail": "tn-timeline-main-11.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Delaware Public Archives, Howard High School",
            "affiliatedPrimarySourcesLink": "https://archives.delaware.gov/2012/01/13/martin-luther-king-jr/",
            "Source image for full view": "timeline_mainevent-11.jpg",
            "Source description": "photo of Howard HS (bottom of page) {delaware arrchives)",
            "topics": "Legal Cases, Segregation",
            "Notes": "not cited in film",
            "highlighted":true,
        },
        {
            "id": 12,
            "title": "Brown v. Board of Education",
            "event": "Thurgood Marshall argues before the U.S. Supreme Court that segregated schools in Topeka, Kansas violate the 14th Amendment. The Court's 9-0 ruling becomes a landmark decision that ends the “separate but equal” doctrine in public education. Many schools in the South still resist integration for years after the ruling.",
            "year": 1954,
            "yearSort": 1954,
            "location": "Washington, D.C.",
            "broaderLoc":["Washington, D.C."],
            "Source type": "video",
            "sourceThumbnail": "tn-timeline-main-12.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Becoming Thurgood: America's Social Architect",
            "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/1106261623?h=d8c79a5057&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" style=\"width:100%;height:100%;\" title=\"Timeline5-BrownvBoard\"></iframe><script src=\"https://player.vimeo.com/api/player.js\"></script>",
            "topics": "Legal Cases, Thurgood Marshall, Civil Rights, Segregation",
            "Notes": "not cited in film",
            "highlighted":true,
        },
        {
            "id": 13,
            "title": "Williams v. Wallace",
            "event": "In March 1965, civil rights activists march from Selma to Montgomery, Alabama, to protest voter suppression. On “Bloody Sunday,” Gov. George Wallace sends troops to attack the peaceful marchers. The Legal Defense Fund petitions a federal court, which blocks further interference. The marches help lead to the Voting Rights Act.",
            "importantPeopleAssociates": ["John Lewis","Hosea Williams"],
            "year": 1965,
            "yearSort": 1965,
            "location": "Selma, Alabama",
            "broaderLoc":["Alabama"],
            "Source type": "document",
            "sourceThumbnail": "tn-timeline-main-13.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Testimony from Hosea Williams, John Lewis, and Amelia Boynton et al. v. Honorable George C. Wallace, Governor of Alabama et al.",
            "affiliatedPrimarySourcesLink": "https://catalog.archives.gov/id/279204?objectPage=5",
            "Source image for full view": "timeline_mainevent-13.jpg",
            "topics": "Legal Cases, Civil Rights",
            "Notes": "not cited in film",
            "highlighted":true,
        },
        {
            "id": 101,
            "event": "The 13th Amendment to the U.S. Constitution is ratified, abolishing slavery in the United States.",
            "year": 1865,
            "yearSort": 1865,
            "location": "Washington, D.C.",
            "broaderLoc":["Washington, D.C."],
            "topics": "Legislation, Politics",
            "Source type": "Illustration",
            "sourceThumbnail": "tn-timeline-misc-1.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Abolishing slavery Joint resolution of thirty eighth Congress of the United States of America",
            "affiliatedPrimarySourcesLink": "https://www.loc.gov/item/2020780910/",
            "Source image for full view": "timeline_miscevent-1.jpg"
        },
        {
            "id": 102,
            "event": "The 15th Amendment to the U.S. Constitution is ratified, granting African American men the right to vote.",
            "year": 1870,
            "yearSort": 1870,
            "location": "Washington, D.C.",
            "broaderLoc":["Washington, D.C."],
            "topics": "Legislation, Politics",
            "Source type": "Print",
            "sourceThumbnail": "tn-timeline-misc-2.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"The Fifteenth amendment",
            "affiliatedPrimarySourcesLink": "https://www.loc.gov/item/93510386/",
            "Source image for full view": "timeline_miscevent-2.jpg"
        },
        {
            "id": 103,
            "event": "Thurgood Marshall is born in Baltimore, Maryland.",
            "year": 1908,
            "yearSort": 1908,
            "location": "Baltimore, MD",
            "broaderLoc":["Maryland"],
            "topics": "Life Events, Thurgood Marshall",
            "Source type": "Illustration",
            "sourceThumbnail": "tn-timeline-misc-3.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"A birds-eye view of the heart of Baltimore.",
            "affiliatedPrimarySourcesLink": "https://www.loc.gov/item/75694536/",
            "Source image for full view": "timeline_miscevent-3.jpg"
        },
        {
            "id": 104,
            "event": "Thurgood Marshall graduates from Frederick Douglass High School in Baltimore, Maryland.",
            "year": 1925,
            "yearSort": 1925,
            "location": "Baltimore, MD",
            "broaderLoc":["Maryland"],
            "topics": "Life Events, Thurgood Marshall",
            "Source type": "photo",
            "sourceThumbnail": "tn-timeline-misc-4.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Courtesy the Maryland Inventory of Historic Properties (B-4210)/Peale Museum. Photograph by the City Buildings Surveys, 1926-1927.",
            "Source image for full view": "timeline_miscevent-4.jpg"
        },
        {
            "id": 105,
            "event": "Thurgood Marshall graduates with honors from Lincoln University, one of the nation’s oldest Historically Black Colleges and Universities (HBCUs).",
            "year": 1930,
            "yearSort": 1930,
            "location": "Chester County, PA",
            "broaderLoc":["Pennsylvania"],
            "topics": "Life Events, Thurgood Marshall",
            "Source type": "video",
            "sourceThumbnail": "tn-timeline-misc-5.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Becoming Thurgood: America's Social Architect",
            "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/1106262545?h=658a932512&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" style=\"width:100%;height:100%;\" title=\"Timeline-Lincoln\"></iframe><script src=\"https://player.vimeo.com/api/player.js\"></script>"
        },

        {
            "id": 106,
            "event": "Thurgood Marshall applies to the University of Maryland School of Law. The Law school bars his application because he is Black.",
            "year": 1930,
            "yearSort": 1930,
            "location": "Baltimore, MD",
            "broaderLoc":["Maryland"],
            "topics": "Life Events, Thurgood Marshall",
            "Source type": "photo",
            "sourceThumbnail": "tn-timeline-misc-6.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"The Terrapin [yearbook] by University of Maryland, College Park",
            "Source image for full view": "timeline_miscevent-6.jpg",
            "affiliatedPrimarySourcesLink":"https://archive.org/details/terrapinyearbook1938univ/page/n1/mode/2up"
        },
        {
            "id": 107,
            "event": "Thurgood Marshall graduates from Howard University School of Law.",
            "importantPeopleAssociates": ["Charles Hamilton Houston"],
            "year": 1933,
            "yearSort": 1933,
            "location": "Washington, D.C.",
            "broaderLoc":["Washington, D.C."],
            "topics": "Life Events, Thurgood Marshall",
            "Source type": "newspaper",
            "sourceThumbnail": "tn-timeline-misc-7.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Baltimore Boy Finishes Law",
            "Source image for full view": "timeline_miscevent-7.jpg",
            "affiliatedPrimarySourcesLink": "https://afro.com/archives/",
        },
        {
            "id": 108,
            "event": "Charles Hamilton Houston mentors Thurgood Marshall at Howard University School of Law, teaching him to use the law for justice. He guides Marshall’s early career at the National Association for the Advancement of Colored People (NAACP), and inspires his civil rights work.",
            "importantPeopleAssociates": ["Charles Hamilton Houston"],
            "year": "1930-1938",
            "yearSort": 1930,
            "location": "Washington, D.C.",
            "broaderLoc":["Washington, D.C."],
            "topics": "Life Events, Thurgood Marshall",
            "Source type": "video",
            "sourceThumbnail": "tn-timeline-misc-8.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Becoming Thurgood: America's Social Architect",
            "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/1106264202?h=ece8ffe67e&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" style=\"width:100%;height:100%;\" title=\"Timeline-CharlesHamiltonHouston\"></iframe><script src=\"https://player.vimeo.com/api/player.js\"></script>"
        },
        {
            "id": 109,
            "event": "Thurgood Marshall founds the NAACP Legal Defense Fund and serves as its first director-counsel.",
            "importantPeopleAssociates": ["Charles Hamilton Houston"],
            "year": 1940,
            "yearSort": 1940,
            "location": "New York, NY",
            "broaderLoc":["New York"],
            "topics": "Civil Rights, Thurgood Marshall",
            "Source type": "video",
            "sourceThumbnail": "tn-timeline-misc-9.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Becoming Thurgood: America's Social Architect",
            "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/1106503011?h=392f0de3d8&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" style=\"width:100%;height:100%;\" title=\"Timeline-LDF\"></iframe><script src=\"https://player.vimeo.com/api/player.js\"></script>"
        },
        {
            "id": 110,
            "event": "The United States enters World War II, deploying troops to Europe and the Pacific. Black soldiers who serve overseas return home to face discrimination and segregation under Jim Crow laws.",
            "year": "1941-1945",
            "yearSort": 1941,
            "location": "Asia, Europe, United States",
            "broaderLoc":["Asia","Europe","United States"],
            "topics": "War, Civil Rights",
            "Source type": "photo",
            "sourceThumbnail": "tn-timeline-misc-10.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Photograph of several Tuskegee airmen at Ramitelli, Italy, March 1945",
            "affiliatedPrimarySourcesLink": "https://www.loc.gov/resource/ppmsca.13259/?",
            "Source image for full view": "timeline_miscevent-10.jpg",
            "hideMap":true,
        },
        {
            "id": 111,
            "event": "During the Cold War, while promoting democracy abroad, the United States faces pressure to confront racial injustice at home.",
            "importantPeopleAssociates": ["Harry S. Truman","John F. Kennedy"],
            "year": "1947-1960",
            "yearSort": 1947,
            "location": "United States",
            "broaderLoc":["United States"],
            "topics": "War, Civil Rights",
            "Source type": "document",
            "sourceThumbnail": "tn-timeline-misc-11.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"NAACP Legal Defense and Educational Fund Records: Subject File, 1929-1968; Housing; Federal Housing Administration",
            "affiliatedPrimarySourcesLink": "https://www.loc.gov/resource/mss65570.mss65570-08507/?sp=2&st=image&r=-0.99,-0.061,2.98,1.427,0",
            "Source image for full view": "timeline_miscevent-11.jpg"
        },
        {
            "id": 112,
            "event": "Nine Black students, known as the Little Rock Nine, integrate Central High School in Little Rock, Arkansas, under the protection of the U.S. Army.",
            "importantPeopleAssociates": ["Dwight D. Eisenhower","Ernest Green"],
            "year": 1957,
            "yearSort": 1957,
            "location": "Little Rock, AR",
            "broaderLoc":["Arkansas"],
            "topics": "Civil Rights",
            "Source type": "video",
            "sourceThumbnail": "tn-timeline-misc-12.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Becoming Thurgood: America's Social Architect",
            "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/1106264254?h=3176c062f5&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" style=\"width:100%;height:100%;\" title=\"Timeline-LittleRock\"></iframe><script src=\"https://player.vimeo.com/api/player.js\"></script>"
        },
        {
            "id": 113,
            "event": "The Rev. Martin Luther King Jr. delivers his “I Have a Dream” speech at the March on Washington for Jobs and Freedom.",
            "importantPeopleAssociates": ["Rev. Dr. Martin Luther King, Jr.","A. Philip Randolph"],
            "year": 1963,
            "yearSort": 1963,
            "location": "Washington, D.C.",
            "broaderLoc":["Washington, D.C."],
            "topics": "Civil Rights",
            "Source type": "photo",
            "sourceThumbnail": "tn-timeline-misc-13.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Civil rights March on Washington, D.C.",
            "affiliatedPrimarySourcesLink": "https://loc.gov/pictures/resource/ppmsca.03128/",
            "Source image for full view": "timeline_miscevents-13.tiff"
        },
        {
            "id": 114,
            "event": "The Civil Rights Act of 1964 is signed into law, banning discrimination based on race, color, religion or national origin.",
            "importantPeopleAssociates": ["Lyndon B. Johnson"],
            "year": 1964,
            "yearSort": 1964,
            "location": "Washington, D.C.",
            "broaderLoc": ["Washington, D.C."],
            "topics": "Civil Rights, Legislation, Politics",
            "Source type": "document/diary",
            "sourceThumbnail": "tn-timeline-misc-14.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Daily Diary, July 2, 1964",
            "affiliatedPrimarySourcesLink": "https://www.lbjlibrary.org/object/document/daily-diary-july-02-1964",
            "Source image for full view": "timeline_miscevent-14.jpg"
        },
        {
            "id": 115,
            "event": "The Southern Christian Leadership Conference and the Student Nonviolent Coordinating Committee organize voting rights marches from Selma to Montgomery.",
            "importantPeopleAssociates": ["Rev. Dr. Martin Luther King, Jr.","John Lewis","Hosea Williams"],
            "year": 1965,
            "yearSort": 1965,
            "location": "Selma, Alabama; Montgomery, Alabama",
            "broaderLoc":["Alabama"],
            "topics": "Civil Rights",
            "Source type": "photo",
            "sourceThumbnail": "tn-timeline-misc-15.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Two Minute Warning",
            "affiliatedPrimarySourcesLink": "https://nmaahc.si.edu/object/nmaahc_2011.14.12",
            "Source image for full view": "timeline_miscevent-15.jpg",
            "Source Descriptions": "permission requested"
        },
        {
            "id": 116,
            "event": "The Voting Rights Act is signed into law, prohibiting racial discrimination in voting.",
            "importantPeopleAssociates": ["Lyndon B. Johnson"],
            "year": 1965,
            "yearSort": 1965,
            "location": "Washington, D.C.",
            "broaderLoc":["Washington, D.C."],
            "topics": "Civil rights, Legislation, Politics",
            "Source type": "photo",
            "sourceThumbnail": "tn-timeline-misc-16.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"President Lyndon B. Johnson Signs the Voting Rights Act as Martin Luther King Jr. and Other Civil Rights Leaders Look on",
            "affiliatedPrimarySourcesLink": "https://catalog.archives.gov/id/2803443",
            "Source image for full view": "timeline_miscevent-16.jpg"
        },
        {
            "id": 117,
            "event": "Thurgood Marshall becomes the first Black justice to serve on the U.S. Supreme Court.",
            "importantPeopleAssociates": ["Lyndon B. Johnson"],
            "year": "1967-1991",
            "yearSort": 1967,
            "location": "Washington, D.C.",
            "broaderLoc":["Washington, D.C."],
            "topics": "Life Events, Thurgood Marshall, Politics",
            "Source type": "video",
            "sourceThumbnail": "tn-timeline-misc-17.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Becoming Thurgood: America's Social Architect",
            "affiliatedPrimarySourcesLink":"<iframe src=\"https://player.vimeo.com/video/1109090925?h=183896d7f5&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" style=\"width:100%;height:100%;\" title=\"Timeline-SupremeCourt\"></iframe>"
        },
        {
            "id": 118,
            "event": "Congress enacts the Fair Housing Act, banning discrimination in the sale, rental or financing of housing.",
            "importantPeopleAssociates": ["Lyndon B. Johnson"],
            "year": 1968,
            "yearSort": 1968,
            "location": "Washington, D.C.",
            "broaderLoc":["Washington, D.C."],
            "topics": "Civil Rights, Legislation, Politics",
            "Source type": "photo",
            "sourceThumbnail": "tn-timeline-misc-18.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Members and supporters of the NAACP picket outside of the Open Occupancy Hearing at Cobo Hall, Detroit, Michigan.",
            "affiliatedPrimarySourcesLink": "https://avoice.cbcfinc.org/exhibit-item/fair-housing/naacp-members-picket-outside-cobo-hall-in-detroit-1963/",
            "Source image for full view": "timeline_event-18.jpg"
        },
        {
            "id": 119,
            "event": "The Thurgood Marshall College Fund is established.",
            "year": 1987,
            "yearSort": 1987,
            "location": "Washington, D.C.",
            "broaderLoc": ["Washington, D.C."],
            "topics": "Legacy",
            "Source type": "image/logo",
            "sourceThumbnail": "tn-timeline-misc-19.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Thurgood Marshall College Fund Pioneering Equality, Justice, and Education",
            "affiliatedPrimarySourcesLink": "https://tmcf.org/about-us/",
            "Source image for full view": "timeline_miscevent_19.jpg"
        },
        {
            "id": 120,
            "event": "Thurgood Marshall dies of heart failure on January 24, 1993.",
            "year": 1993,
            "yearSort": 1993,
            "location": "Bethesda, MD",
            "broaderLoc":["Maryland"],
            "topics": "Life Events, Thurgood Marshall",
            "Source type": "video",
            "sourceThumbnail": "tn-timeline-misc-20.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Becoming Thurgood: America's Social Architect",
            "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/1106266420?h=c206f0679d&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" style=\"width:100%;height:100%;\" title=\"Timeline-Funeral\"></iframe><script src=\"https://player.vimeo.com/api/player.js\"></script>"
        },
        {
            "id": 121,
            "event": "Baltimore/Washington International Airport is renamed Baltimore/Washington International Thurgood Marshall Airport.",
            "year": 2005,
            "yearSort": 2005,
            "location": "Anne Arundel County, MD",
            "broaderLoc":["Maryland"],
            "topics": "Legacy",
            "Source type": "image",
            "sourceThumbnail": "tn-timeline-misc-21.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Thurgood Marshall Biography",
            "affiliatedPrimarySourcesLink": "https://bwiairport.com/flying-with-us/about-bwi/thurgood-marshall/",
            "Source image for full view": "timeline_miscevent-21.jpg"
        },
        {
            "id": 122,
            "event": "Barack Obama is elected the 44th president of the United States, becoming the first Black person to hold the office.",
            "year": 2008,
            "yearSort": 2008,
            "location": "Washington, D.C.",
            "broaderLoc":["Washington, D.C."],
            "topics": "Legacy, Politics",
            "Source type": "photo",
            "sourceThumbnail": "tn-timeline-misc-22.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"2009 Inaugural Parade. Michelle and Barack Obama",
            "affiliatedPrimarySourcesLink": "https://www.loc.gov/item/2010647151/",
            "Source image for full view": "timeline_miscevent-22.jpg"
        },
        {
            "id": 123,
            "event": "Kamala Harris becomes the 49th vice president of the United States. She is the first woman, the first Black American and the first South Asian American elected to the role.",
            "year": 2021,
            "yearSort": 2021,
            "location": "Washington, D.C.",
            "broaderLoc":["Washington, D.C."],
            "topics": "Legacy, Politics",
            "Source type": "photo",
            "sourceThumbnail": "tn-timeline-misc-23.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Official portrait of Vice President Kamala Harris",
            "affiliatedPrimarySourcesLink": "https://www.loc.gov/item/2021630113/",
            "Source image for full view": "timeline_miscevent-23.jpg"
        },
        {
            "id": 124,
            "event": "Ketanji Brown Jackson becomes the first Black woman to serve on the U.S. Supreme Court.",
            "year": 2022,
            "yearSort": 2022,
            "location": "Washington, D.C.",
            "broaderLoc":["Washington, D.C."],
            "topics": "Legacy, Politics",
            "Source type": "photo",
            "sourceThumbnail": "tn-timeline-misc-24.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Oath Ceremony: The Honorable Ketanji Brown Jackson",
            "affiliatedPrimarySourcesLink": "https://www.supremecourt.gov/publicinfo/press/oath/oath_jackson.aspx",
            "Source image for full view": "timeline_miscevent-24.jpg"
        },

    ]
    
}

export default data;